import React from 'react';
import { useIntl } from 'react-intl';
import { Checkbox } from 'semantic-ui-react';

const DatasetConditionAdvisoryToggle = ({ advisory, disabled, onClick }) => {
  const intl = useIntl();
  return (
    <div className="aridhia-dataset-condition-advisory-toggle aridhia-modal-actions-checkbox">
      <Checkbox
        label={intl.formatMessage({ id: 'dataset.condition.compatible.label' })}
        toggle
        onClick={disabled ? undefined : () => onClick(!advisory)}
        checked={!advisory}
        disabled={disabled}
      />
    </div>
  );
};

export default DatasetConditionAdvisoryToggle;
